import { __rest } from '../node_modules/tslib/tslib.es6.js';
import { motion } from 'framer-motion';
import React__default, { useRef } from 'react';
import { cn } from '../lib/utils.js';

const StoreCarousel = (_a) => {
    var { children, styleProps } = _a, props = __rest(_a, ["children", "styleProps"]);
    const carouselRef = useRef(null);
    const itemRefs = useRef([]);
    return (React__default.createElement("div", Object.assign({ className: cn('tw:relative tw:w-full tw:max-w-full tw:overflow-hidden tw:flex tw:justify-start tw:items-center') }, styleProps),
        React__default.createElement("style", null, `
        .store-carousel-scroll::-webkit-scrollbar {
          display: none;
        }
      `),
        React__default.createElement(motion.div, Object.assign({ key: children.length, ref: carouselRef, style: {
                gap: '15px',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none', // IE/Edge
            }, className: cn('store-carousel-scroll', 'tw:flex tw:overflow-auto tw:[scroll-snap-type:x_mandatory]') }, props), React__default.Children.map(children, (child, index) => (React__default.createElement("div", { className: "tw:snap-start tw:shrink-0", ref: (ref) => {
                const current = itemRefs.current[index];
                if (current && !ref) {
                    itemRefs.current = itemRefs.current.filter((_, i) => i !== index);
                    return;
                }
                itemRefs.current[index] = ref;
            }, key: index }, child))))));
};

export { StoreCarousel as default };
//# sourceMappingURL=StoreCarousel.js.map
